import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { acme, acmeDialogPaperSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/**
 * Mobile sheet / drawer (see Tanplates/sheets.js).
 * side: left | right | top | bottom
 */
export function Sheet({ open, onClose, side = 'right', width = 300, children, sx }) {
  const anchor = side === 'top' ? 'top' : side === 'bottom' ? 'bottom' : side;

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: mergeSx(
          {
            ...acmeDialogPaperSx,
            width: side === 'left' || side === 'right' ? { xs: '85%', sm: width } : '100%',
            maxWidth: side === 'left' || side === 'right' ? width : 'none',
            p: 3,
          },
          sx,
        ),
      }}
    >
      {children}
    </Drawer>
  );
}

export function SheetHeader({ title, description, onClose, sx }) {
  return (
    <Box sx={mergeSx({ mb: 2, position: 'relative' }, sx)}>
      {onClose && (
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', right: -8, top: -8 }}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      {title && (
        <Typography sx={{ fontWeight: 600, fontSize: '1.125rem', color: acme.colors.foreground }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography sx={{ fontSize: '0.875rem', color: acme.colors.mutedForegroundSolid, mt: 0.5 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

export function SheetBody({ sx, children, ...props }) {
  return (
    <Box sx={mergeSx({ display: 'flex', flexDirection: 'column', gap: 2 }, sx)} {...props}>
      {children}
    </Box>
  );
}

Sheet.Header = SheetHeader;
Sheet.Body = SheetBody;

export default Sheet;
